module.exports = __webpack_public_path__ + "img/logo_color.337070a1.png";